'use client';
import { useEffect, useRef } from 'react';
export function MusicVisualizer({ analyser, playing }: { analyser: AnalyserNode | null; playing: boolean }) {
  const canvas = useRef<HTMLCanvasElement>(null);
  useEffect(() => {
    const element = canvas.current, context = element?.getContext('2d'); if (!element || !context) return;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)'); let timer = 0;
    const data = new Uint8Array(analyser?.frequencyBinCount || 32);
    const draw = () => {
      context.clearRect(0, 0, 96, 24); context.fillStyle = '#315f44';
      if (analyser && playing && !document.hidden && !reduced.matches && element.getClientRects().length > 0) analyser.getByteFrequencyData(data);
      else data.fill(0);
      for (let i = 0; i < 12; i++) { const height = Math.max(2, data[i * 2] / 255 * 22); context.fillRect(i * 8, 24 - height, 4, height); }
    };
    const update = () => { clearInterval(timer); draw(); if (playing && analyser && !document.hidden && !reduced.matches && element.getClientRects().length > 0) timer = window.setInterval(draw, 1000 / 15); };
    const resize = new ResizeObserver(update); resize.observe(element);
    update(); document.addEventListener('visibilitychange', update); reduced.addEventListener('change', update);
    return () => { clearInterval(timer); resize.disconnect(); document.removeEventListener('visibilitychange', update); reduced.removeEventListener('change', update); };
  }, [analyser, playing]);
  return <canvas ref={canvas} width={96} height={24} aria-hidden="true" className="music-visualizer" />;
}
